import { FC } from 'react';
import ApiListDemo from './demos/ApiDemo';


const App: FC = () => {
  return (
    <ApiListDemo />
  );
}


export default App;
